import { useEffect, useState } from 'react'
import api from '../../../../helpers/apiRequester'
import styles from './mhlShared.module.scss'
import { useMhlAccess } from './useMhlAccess'

const REFRESH_MS = 5 * 60 * 1000

/**
 * Small amber count of clients awaiting review, rendered next to the sidebar
 * "Clients" link. Only fetches for MHL admins (the reviewers); renders
 * nothing for everyone else or when the queue is empty.
 */
export const MhlReviewBadge = () => {
    const { isMhlAdmin } = useMhlAccess()
    const [count, setCount] = useState<number>(0)

    useEffect(() => {
        if (!isMhlAdmin) return
        let cancelled = false
        const fetchCount = async () => {
            try {
                const res = await api({ url: '/military-hearing-loss-review-queue-count', data: {} })
                if (!cancelled && res.data?.success) setCount(Number(res.data.awaiting) || 0)
            } catch {
                /* badge is best-effort */
            }
        }
        void fetchCount()
        const timer = window.setInterval(fetchCount, REFRESH_MS)
        return () => {
            cancelled = true
            window.clearInterval(timer)
        }
    }, [isMhlAdmin])

    if (!isMhlAdmin || count <= 0) return null
    return (
        <span className={styles.badgeCount} title={`${count} awaiting review`}>
            {count > 99 ? '99+' : count}
        </span>
    )
}
